// extracted by mini-css-extract-plugin
module.exports = {"Checkbox":"Checkbox_Checkbox_2bV4E","Content":"Checkbox_Content_2qVdR"};